import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit, inject } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { TegelModule } from '@scania/tegel-angular-17';
import { HeaderComponent } from './core/components/header/header.component';
import { SideMenuComponent } from './core/components/side-menu/side-menu.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { ToastComponent } from './shared/components/toast/toast.component';
import { MsalModule, MsalService } from '@azure/msal-angular';
import { UserService } from './core/services/user.service';
import { SpinnerComponent } from '@componentsShare/spinner/spinner.component';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    MsalModule,
    HeaderComponent,
    SideMenuComponent,
    FooterComponent,
    ToastComponent,
    SpinnerComponent
    
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  isIntroRoute = false;

  title(): string {
  return 'ARGON';
  }

  constructor(
    private authService: MsalService,
    private userService: UserService,
    private router: Router
  ) {
    // this.router.events
    //   .pipe(filter((event) => event instanceof NavigationEnd))
    //   .subscribe((event: NavigationEnd) => {
    //     this.isIntroRoute = event.urlAfterRedirects.startsWith('/intro');
    //   });
  }

  ngOnInit(): void {
    this.authService.handleRedirectObservable().subscribe({
      next: () => {
        const accounts = this.authService.instance.getAllAccounts();
        if (accounts.length === 0) {
          this.authService.initialize().subscribe({
            next: () => {
              this.authService.loginRedirect();
            }
          });
        } else {
          const account = accounts[0].idTokenClaims!;
          this.userService.setRoles(account.roles!);
          this.userService.setUser(account.name!, account.preferred_username!);
        }
      }
    });
  }

  showFullLayout(): boolean {
    return this.router.url !== '/';
  }
}
